module.exports = __webpack_public_path__ + "img/uploaded-tick.cf357bb5.svg";